// extracted by mini-css-extract-plugin
var _1 = "styles-module__profileSlidingTabsContainer___KkU1T";
var _2 = "styles-module__tabBar___eDRlc";
export { _1 as "profileSlidingTabsContainer", _2 as "tabBar" }
